import React from 'react';
import TarefasAtivasDepartamento from '../components/tarefas/TarefasAtivasDepartamento';
import { Box, Container } from '@mui/material';

const TarefasAtivasDepartamentoPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 2 }}>
        <TarefasAtivasDepartamento />
      </Box>
    </Container>
  );
};

export default TarefasAtivasDepartamentoPage;
